namespace TabAurous.Retail {
    export namespace OrderAmazonImportService {
        export const baseUrl = 'Retail/OrderAmazonImport';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/OrderAmazonImport/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderAmazonImportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
